// Header.jsx
import { Text, View } from "@react-pdf/renderer";
import AnnualGuideStyles from "./styles/dccReportStyles";

const Header = ({ primaryColor }) => {
  const styles = AnnualGuideStyles(primaryColor || "081e56");

  return (
    <View style={styles.pageHeader} fixed>
      <Text style={styles.pageHeaderText}>{`Debt Consolidation`}</Text>
      <Text
        style={styles.pageHeaderText}
        render={({ pageNumber, totalPages }) => `Page ${pageNumber}`}
      />
    </View>
  );
};

export default Header;
